// src/pages/ViewTeams.js
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { fetchUserTeams } from '../../api/userTeams';
import { fetchUserGames } from '../../api/games';
import { filterTempTeams } from '../../helpers/teamHelpers';
import { useAtom } from 'jotai';
import { currentUserAtom } from '../../auth/AuthAtoms';
import { toast } from 'react-toastify';
import TeamList from '../../components/TeamList';

const ViewTeams = () => {
    const [currentUser] = useAtom(currentUserAtom);
    const [teams, setTeams] = useState([]);
    const [hasGames, setHasGames] = useState(true);
    const location = useLocation();

    const fetchUserTeamsData = useCallback(async () => {
        if (!currentUser) return;

        try {
            const [teamsData, gamesData] = await Promise.all([
                fetchUserTeams(),
                fetchUserGames().catch(() => []),
            ]);
            setTeams(filterTempTeams(teamsData));
            setHasGames((gamesData || []).length > 0);
        } catch (error) {
            console.error('Error fetching user teams:', error);
        }
    }, [currentUser]);

    useEffect(() => {
        if (currentUser) {
            fetchUserTeamsData();
        }

        if (location.state?.message) {
            toast.success(location.state.message);
        }
    }, [currentUser, fetchUserTeamsData, location.state]);

    return (
        <div className="user-teams-page">
            <div className="teams-page-header">
                <h2>User Teams</h2>
                <Link to="/team/create" className="create-team-btn">+ Create New Team</Link>
            </div>
            <TeamList teams={teams} onRefetch={fetchUserTeamsData} />
            {teams.length > 0 && !hasGames && (
                <div className="teams-play-nudge">
                    <p>Your team is ready &mdash; time to play your first game.</p>
                    <Link to="/campaigns" className="button">Play a Campaign &rarr;</Link>
                </div>
            )}
        </div>
    );
};

export default ViewTeams;
